import { render } from "./StepHowDidYouHearAboutUs.vue?vue&type=template&id=076996f4"
import script from "./StepHowDidYouHearAboutUs.vue?vue&type=script&lang=js"
export * from "./StepHowDidYouHearAboutUs.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__